var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GGGroup', {
    staticClass: "gg-sale-grid",
    attrs: {
      "prop": _vm.data.template.prop
    },
    scopedSlots: _vm._u([_vm.length ? {
      key: "content",
      fn: function () {
        return [_vm.gridType === '1x3' || _vm.gridType === '1x6' || (_vm.gridType === '2x3' || _vm.gridType === '2x6') && _vm.length < 6 ? [_c('ViewportToogle', {
          scopedSlots: _vm._u([{
            key: "desktop",
            fn: function () {
              return [_c('GGRowSlider', {
                attrs: {
                  "list": _vm.list,
                  "offset-between-elements": 15
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref) {
                    var el = _ref.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": _vm.gridType === '1x6' && _vm.length >= 6 ? 's' : 'm'
                      }
                    })];
                  }
                }], null, false, 3540219129)
              })];
            },
            proxy: true
          }, {
            key: "mobile",
            fn: function () {
              return [_c('GGRowSlider', {
                attrs: {
                  "list": _vm.list,
                  "offset-between-elements": 5
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref2) {
                    var el = _ref2.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": _vm.gridType === '1x6' && _vm.length >= 6 ? 's' : 'm'
                      }
                    })];
                  }
                }], null, false, 3540219129)
              })];
            },
            proxy: true
          }], null, false, 431505482)
        })] : _vm._e(), _vm._v(" "), _vm.length >= 6 && (_vm.gridType === '2x3' || _vm.gridType === '2x6') ? [_c('ViewportToogle', {
          scopedSlots: _vm._u([{
            key: "desktop",
            fn: function () {
              return [_c('GGRowSlider', {
                attrs: {
                  "list": _vm.rows[0],
                  "offset-between-elements": 15
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref3) {
                    var el = _ref3.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": "m"
                      }
                    })];
                  }
                }], null, false, 748650532)
              }), _vm._v(" "), _vm.rows[1].length ? _c('GGRowSlider', {
                staticClass: "gg-sale-grid__second-row",
                attrs: {
                  "list": _vm.rows[1],
                  "offset-between-elements": 15
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref4) {
                    var el = _ref4.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": _vm.rows[1].length < 6 ? 'm' : 's'
                      }
                    })];
                  }
                }], null, false, 1441311940)
              }) : _vm._e()];
            },
            proxy: true
          }, {
            key: "mobile",
            fn: function () {
              return [_c('GGRowSlider', {
                attrs: {
                  "list": _vm.rows[0],
                  "offset-between-elements": 5
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref5) {
                    var el = _ref5.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": "m"
                      }
                    })];
                  }
                }], null, false, 748650532)
              }), _vm._v(" "), _vm.rows[1].length ? _c('GGRowSlider', {
                staticClass: "gg-sale-grid__second-row",
                attrs: {
                  "list": _vm.rows[1],
                  "offset-between-elements": 5
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref6) {
                    var el = _ref6.el;
                    return [_c('GGSaleCard', {
                      attrs: {
                        "data": el,
                        "size": _vm.rows[1].length < 6 ? 'm' : 's'
                      }
                    })];
                  }
                }], null, false, 1441311940)
              }) : _vm._e()];
            },
            proxy: true
          }], null, false, 420156731)
        })] : _vm._e()];
      },
      proxy: true
    } : null], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }